import * as types from '../mutation-types'

/*
  Module for showing and closing modals
*/

const state = {
  refresh_password_modal_opened: false
}

const getters = {
  // The currently open top modal's name
  refreshPasswordOpened: (state, getters) => () => {
    return state.refresh_password_modal_opened
  } 
}

const mutations = {
  [types.OPEN_REFRESH_PASSWORD] (state)  {
    state.refresh_password_modal_opened = true
  },
  [types.CLOSE_REFRESH_PASSWORD] (state)  {
    state.refresh_password_modal_opened = false
  }
}


export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/modals.js